import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SsoCallbackRoutingModule } from './sso-callback-routing.module';
import { SsoCallbackComponent } from './sso-callback.component';
import { AlertService } from '@app/@core/services/alert.service';

@NgModule({
  declarations: [SsoCallbackComponent],
  imports: [CommonModule, SsoCallbackRoutingModule],
  providers: [AlertService],
})
export class SsoCallbackModule {}
